import { ChangeEvent, FunctionComponent } from "react";

export interface CheckBoxProps {
  id?: string;
  checked?: boolean;
  label?: string | React.ReactNode;
  error?: boolean;
  errorText?: String;
  setChecked?: (value: boolean, id?: string) => void;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  showLabel?: boolean;
  disabled?: boolean;
}

const CheckBox: FunctionComponent<CheckBoxProps> = ({
  id,
  label,
  error,
  errorText,
  disabled,
  checked,
  onChange,
}) => {
  return (
    <>
      <label className="inline-flex items-center text-left cursor-pointer">
        <input
          type="checkbox"
          className={`h-4 w-4 rounded-sm ${
            error ? "border-red-500" : "border-gray-300"
          } focus:border-primary focus:ring-0 focus:ring-indigo-200 focus:ring-opacity-50 text-primary`}
          checked={checked}
          disabled={disabled === true}
          onChange={(e) => onChange && onChange(e)}
        />
        <span className="ml-2 text-sm ">{label}</span>
      </label>
      {error ? (
        <p className="ml-10 mt-2 text-xs text-red-500">{errorText}</p>
      ) : null}
    </>
  );
};

export default CheckBox;
